module.exports = __webpack_public_path__ + "img/add-member-big.fc3e47ba.svg";